export default {
  namespace: 'parkings',
  state: {
    showAll: undefined
  },
  actions: {
    setShowAll(state, { showAll }) {
      return {
        ...state,
        showAll
      };
    },
  }
};
